import React from 'react'
import AddUser from './AddUser'

function Tables() {
  return (
    <div style={{ marginLeft: '20px', marginRight: '20px', marginTop: '20px' }}>
      <AddUser />
    </div>
  )
}

export default Tables
